export default "__VITE_ASSET__DjJ0b_8U__"